import React from "react";
import ReactPlayer from "react-player";
import "./VideoComp.scss";

function getUrl(url) {
  console.log("url", url.video.videoSrc);
  if (url.video.videoSrc) {
    return url.video.videoSrc;
  } else {
    return url.video;
  }
}
function getDimensions(url) {
  if (url.video.width) {
    return url.video.width;
  } else {
    return "100%";
  }
  // if (url.video.height) {
  //   return url.video.height;
  // } else {
  //   return "auto";
  // }
}
function VideoComp(props) {
  console.log("inseide", props.video.width);
  return (
    <div className="video-chapter">
      <ReactPlayer
        url={getUrl(props)}
        playbackRate={1}
        width={`${getDimensions(props)}`}
        height={`auto`}
        playing={true}
        muted={props.muted}
        loop={true}
        controls={true}
      />
    </div>
  );
}
export default VideoComp;
